<template>
    <div class="mds-loader" :class="sizeClass" role="progressbar" aria-valuetext="Please wait, page is loading...">
        <div class="mds-loader__item mds-loader__item--1"></div>
        <div class="mds-loader__item mds-loader__item--2"></div>
        <div class="mds-loader__item mds-loader__item--3"></div>
        <div class="mds-loader__item mds-loader__item--4"></div>
        <div class="mds-loader__item mds-loader__item--5"></div>
        <div class="mds-loader__item mds-loader__item--6"></div>
        <div class="mds-loader__item mds-loader__item--7"></div>
        <div class="mds-loader__item mds-loader__item--8"></div>
    </div>
</template>

<script>
export default {
    name: "mds-loader",
    props: {
        size: {
            type: String,
            default: "medium",
            validator: function(value) {
                return ["small", "medium", "large"].indexOf(value) !== -1;
            }
        }
    },
    computed: {
        sizeClass() {
            return {
                [`mds-loader--${this.size}`]: this.size !== "medium"
            };
        }
    }
};
</script>
